package io.michaelrocks.libphonenumber.kotlin

/** Exception class for cases when expected metadata cannot be found.  */
class MissingMetadataException(message: String?) : IllegalStateException(message)
